import React from 'react';
import { Header } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/header.less';

export default Header;
